import webcrypto from './webcrypto.ts'

export default webcrypto
